module.exports = __webpack_public_path__ + "img/hometile_lg.5bf635b6.png";